import { render, staticRenderFns } from "./CutScene.vue?vue&type=template&id=18563324&"
import script from "./CutScene.vue?vue&type=script&lang=ts&"
export * from "./CutScene.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports